import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/font.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Reset } from 'styled-reset'
import { GlobalStyles } from './styles/GlobalStyles'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Reset />
    <GlobalStyles />
    <App />
  </React.StrictMode>
);

reportWebVitals();
